import React, { useState } from 'react';
import { Drawer, Button, Spin, Row, Col } from 'antd';
import { Document, Page, pdfjs } from 'react-pdf';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import {
	printDataAnalysisReport
} from 'services/settings/reports';
import HttpCodeMessage from 'shared_components/message_http_status';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function ViewReport(props) {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setPageNumber(1);
    };

    const onNav = (direction) => {
        if (direction === 'BACK' && pageNumber > 1) {
            setPageNumber(pageNumber - 1);
        } else if (direction === 'NEXT' && pageNumber < numPages) {
            setPageNumber(pageNumber + 1);
        }
    };

    const handlePrint = async () => {
        const moduleName = props.section[0].sectionName;
        const filename = props.printResponse.paramvalues[0].filename;
    
        // Find the last index of '.' and get the substring before it
        const filenameWithoutExtension = filename.substring(0, filename.lastIndexOf('.'));
    
        const payload = [
            {
                "filename": filenameWithoutExtension,
                "filetype": "pdf"
            }
        ];
    
        try {
            const print = await printDataAnalysisReport(moduleName, payload);
    
            // @ts-ignore
            if (print.status === 200 && print.data && print.data.records.length > 0) {
                HttpCodeMessage({
                    // @ts-ignore
                    status: print.status,
                    // @ts-ignore
                    message: print.data.message,
                });
    
                // Add a 2-second delay before calling onClose
                if (typeof props.onClose === 'function') {
                    setTimeout(() => {
                        props.onClose();
                    }, 2000);
                }
            } else {
                console.error("Printing failed or no records found.");
                HttpCodeMessage({
                    // @ts-ignore
                    status: print.status,
                    message: "Printing failed or no records found.",
                });
            }
        } catch (error) {
            console.error("An error occurred while printing:", error);
            HttpCodeMessage({
                status: error.response ? error.response.status : 500,
                message: error.message,
            });
        }
    };

    return (
        <div>
            <Drawer
                title={props.title}
                width="720px"
                height="80%"
                placement="right"
                closable
                onClose={props.onClose}
                visible={props.open}
                bodyStyle={{ padding: 0 }}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Button shape="round" style={{ margin: 10, width: 120 }} onClick={props.onClose}>
                            CANCEL
                        </Button>
                        <Button shape="round" type="primary" style={{ margin: 10, width: 120 }} onClick={handlePrint}>
                            PRINT
                        </Button>
                    </div>
                }
            >
                <Spin spinning={!props.base64Response}>
                    {props.base64Response ? (
                        <div style={{ padding: '20px', height: 'calc(100vh - 140px)' }}>
                            <Document
                                file={`data:application/pdf;base64,${props.base64Response}`}
                                onLoadSuccess={onDocumentLoadSuccess}
                                onLoadError={console.error}
                                renderMode="svg"
                            >
                                <Page pageNumber={pageNumber} renderMode="svg" />
                            </Document>
                            <Row style={{ marginTop: '10px' }}>
                                <Col span={8}>
                                    {numPages > 1 && (
                                        <>
                                            <Button
                                                type="text"
                                                icon={<CaretLeftOutlined />}
                                                onClick={() => onNav('BACK')}
                                            />
                                            <Button
                                                type="text"
                                                icon={<CaretRightOutlined />}
                                                onClick={() => onNav('NEXT')}
                                            />
                                        </>
                                    )}
                                </Col>
                                <Col span={8} offset={8}>
                                    <p style={{ textAlign: 'right' }}>
                                        Page {pageNumber} of {numPages}
                                    </p>
                                </Col>
                            </Row>
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center' }}>
                            <Spin size="large" />
                        </div>
                    )}
                </Spin>
            </Drawer>
        </div>
    );
}
